import React, { useState, useEffect } from 'react'
//import { useParams } from 'react-router-dom'
import { useSelector } from 'react-redux'

import { Panel, Message } from 'rsuite'
import {
  Row,
  Col,
  ControlLabel,
  FormGroup,
  SelectPicker,
  Button,
  Icon,
  ButtonGroup,
  IconButton,
} from 'rsuite'
import { useForm, Controller } from 'react-hook-form'
import RoleNameWidget from './RoleNameWidget'
import RoleWidget from './RoleWidget'

export default function UsersRoleSubProject(props) {
  const { showCommandButton, isEdit, onChangeIsEdit } = props
  const [section, setSection] = useState()
  const [isError, setIsError] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const { register, handleSubmit, errors, control, getValues, setValue, setError, clearErrors } =
    useForm()
  const [formSchema, setFormSchema] = useState(props.schema)

  //const projectId = useSelector((state) => state.getParameter?.projectId)
  const projectId = sessionStorage.getItem('projectId')

  useEffect(() => {
    console.log('load ProjectName projectId', projectId)
  }, [])

  return (
    <>
      {formSchema.roleName && (
        <RoleNameWidget
          schema={formSchema.roleName}
          register={register}
          Controller={Controller}
          control={control}
          errors={errors}
          getValues={getValues}
          setValue={setValue}
          clearErrors={clearErrors}
        />
      )}

      <br />

      {formSchema.role && (
        <RoleWidget
          schema={formSchema.role}
          register={register}
          Controller={Controller}
          control={control}
          errors={errors}
          isEdit={isEdit}
          getValues={getValues}
          setValue={setValue}
          clearErrors={clearErrors}
        />
      )}
    </>
  )
}
